<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" :before-close="closeDialog" width="70%">

    <!-- 基本信息表单 -->
    <div class="form-box">


      <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 65vh;">

        <div style="display: flex;">


          <el-form-item label="乘客手机号:" label-width='100px'>

            <el-input v-model="phone" style="width: 150px;margin-right: 5px;" maxlength=11
              @keyup.enter.native="getConsumerCode"></el-input>
            <el-button @click="getConsumerCode">搜索</el-button>

          </el-form-item>

        </div>


        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" height="50vh" ref="multipleTable"
          header-cell-class-name="table-header" @selection-change="handleSelectionChange">


          <el-table-column type="selection" width="55" align="center" prop="coupon_mode_code"></el-table-column>


          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <div>
                  <el-form-item label="备注:">
                    <span>{{ props.row.description }}</span>
                  </el-form-item>
                </div>


              </el-form>
            </template>
          </el-table-column>


          <el-table-column prop="name" label="优惠券名称">
          </el-table-column>

          <el-table-column prop="full_price" label="满足金额">
            <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{ scope.row.full_price }}
              </span>元
            </template>
          </el-table-column>

          <el-table-column prop="sub_price" label="优惠金额">
            <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{ scope.row.sub_price }}
              </span>元
            </template>
          </el-table-column>

          <el-table-column prop="bear_price" label="司机承担金额">
            <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{ scope.row.bear_price }}
              </span>元
            </template>
          </el-table-column>


          <el-table-column prop="bear_price" label="发放数量" width="100">
            <template slot-scope="scope">
              <div style="display: flex;">
                <el-input v-model="numLists[scope.row.index].num"></el-input>

                <span>张</span>

              </div>

            </template>
          </el-table-column>


        </el-table>





      </el-form>

      <!-- 对话框底部按钮 -->
      <div style="display: flex;justify-content: center">
        <el-button type="primary" v-if="loading" icon="el-icon-loading"></el-button>
        <el-button @click="sendSubmit" type="primary" v-else>发放</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  import bus from '@/components/common/bus.js';
  export default {
    props: {
      'isShow': Boolean,
    },
    components: {

    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;



      },

    },
    data() {
      return {
        show: false,

        phone: '',
        loading: false,

        tableData: [],

        send_data: [],

        numLists: [],

        //翻页数据
        search_data_children: {
          consumer_code: ''
        },

        submit_data: {
          consumer_code: '',
          coupon_mode_code_num_synchronization: ''
        },


      };
    },
    created() {

      _this = this;
      // 接收http.js文件传来的通知
      bus.$on("btnStatus", (msg) => {
        this.loading = msg;
      });

    },
    methods: {
      // 获取乘客编码
      getConsumerCode() {

        if (_this.phone.length == 11) {

          _this.$post(
            '/consumer/consumerLists', {
            page: 1,
            limit: 10,
            phone: _this.phone
          }
          )
            .then(res => {

              _this.search_data_children.consumer_code = res.data[0].consumer_code
              _this.submit_data.consumer_code = res.data[0].consumer_code;

              _this.SendCoupon();

            }).catch((err) => {

            });

        } else {
          _this.$message.error('手机号长度必须为11位')
        }

      },

      sendSubmit() {

        console.log(this.send_data);
        console.log(this.numLists);
        _this.loading = true;
        let synchronization_data = [];

        // 遍历send_data数组
        for (var i = 0; i < _this.send_data.length; i++) {

          // 遍历numLists数组
          for (var j = 0; j < _this.numLists.length; j++) {

            // numLists数组中存在被选中的code
            if (_this.send_data[i] == _this.numLists[j].code) {

              synchronization_data.push({
                coupon_mode_code: _this.numLists[j].code,
                num: _this.numLists[j].num
              });

              _this.submit_data.coupon_mode_code_num_synchronization = JSON.stringify(synchronization_data)

            }
          }
        }

        console.log(_this.submit_data);



        _this.$post(
          '/coupon/addOneConsumerMoreCouponSubmit',
          _this.submit_data
        )
          .then(res => {

            _this.$message.success(res.msg);
            _this.loading = false;
            _this.closeDialog();


          }).catch((err) => {

          });





      },

      // 表格选中事件
      handleSelectionChange(val) {


        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].coupon_mode_code);

          for (var j = 0; j < _this.numLists.length; j++) {

            // 选中项数量变为1
            if (val[i].coupon_mode_code == _this.numLists[j].code) {

              _this.numLists[j].num = '1';
            }
          }

        }


        _this.send_data = datalist;



      },
      SendCoupon() {
        _this.$post(
          '/coupon/consumerCanSendCouponMode',
          _this.search_data_children
        ).then(res => {

          // 将获取到的数据赋值

          _this.tableData = res.data.result;

          for (var i = 0; i < res.data.result.length; i++) {

            _this.tableData[i].index = i;

            _this.numLists.push({
              num: '0',
              code: _this.tableData[i].coupon_mode_code
            });


            console.log(_this.tableData);

          }


        }).catch((err) => {

        });
      },
      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          consumer_code: '',
          coupon_mode_code_num_synchronization: ''
        };

        _this.search_data_children = {
          consumer_code: ''
        };

        _this.tableData = [];
        _this.send_data = [];
        _this.numLists = [];


      }


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>
